import React from 'react';

import FooterShared from '@landing_academy/shared/components-mantine/Footer';

import Logo from '../../images/MathxLogo';
import { useGuidesData } from '../../hooks/guide';
import { useLandingData } from '../../hooks/homePage';
import { useSiteMetadata } from '../../hooks/metadata';


function Footers() {
  const { tagLine } = useLandingData();
  const { youtube, whatsapp, instagram } = useSiteMetadata();
  const guide = useGuidesData();

  return (
    <FooterShared
      siteMetaData={{ youtube, whatsapp, instagram }}
      landingData={{ tagLine }}
      guide={guide}
      logo={<Logo />}
    />
  );
}

export default Footers;
